import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonLinkComponent } from './link/button.component';
import { ButtonFooterComponent } from './footer/button.component';
import { ButtonComponent } from './button/button.component';
import { ButtonFabComponent } from './fab/button.component';
import { ButtonIconComponent } from './icon/button.component';

@NgModule({
    declarations: [
        ButtonComponent,
        ButtonLinkComponent,
        ButtonFooterComponent,
        ButtonFabComponent,
        ButtonIconComponent
    ],
    exports: [
        ButtonComponent,
        ButtonLinkComponent,
        ButtonFooterComponent,
        ButtonFabComponent,
        ButtonIconComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule
    ]
})
export class AjinButtonModule {
}
